import React, { useEffect, useState, useRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import imageCompression from 'browser-image-compression'
import moment from 'moment';
import dotenv from 'dotenv'
import { set } from 'date-fns'
import { useLocation } from 'react-router';
import { 
    loadCoachProfile,
    loadCoachProfileList,
} from '../../modules/app/coachProfile'
import { loadCoach } from '../../modules/coach/coach';
import { 
    init,
    initRes
} from '../../modules/app/kioskProduct'
import { modifyKioskProduct } from '../../modules/app/kioskProduct';
import { listItems } from '../../modules/item/items';
import { 
    loadTemplate,
} from '../../modules/app/template'
import {
  inputNumberAutoComma,
  inputNumberRemoveComma,
  uploadImageToServer,
  hasEmoji,
} from '../../lib/commonFunc/commonFunc';
import LoadingBlock from '../../components/common/LoadingBlock'
import { sale } from '../../lib/api/locker';

import KioskProductRegist from '../../components/app/KioskProductRegist';
dotenv.config()

const KioskProductRegistContainer = ({ history }) => {
  const {
    club,
    socketKey,
    templateList,
    items,
    modifyRes,
    coachProfileList,
    user,
    coach,
  } = useSelector(({ items, template, coach, user, kioskProduct, mobileProduct, coachProfile, club, socket }) => ({
    club: club.defaultClub,
    user: user.user,
    socketKey: socket.socketKey,
    coach: coach.coaches,
    templateList: template.templateList,
    items: items.items,
    modifyRes: kioskProduct.modifyRes,
    coachProfileList: coachProfile.coachProfileList,
  }));

  const fileInputRef = useRef(null);
  const mainImageInputRef = useRef(null);
  
  const location = useLocation();
  const dispatch = useDispatch()

  const [isEdit, setIsEdit] = useState(false)
  const [membershipType, setMembershipType] = useState(1)
  const [membershipKind, setMembershipKind] = useState(1)
  
  const [imageLoading, setImageLoading] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [type1Contents, setType1Contents] = useState("");
  const [isDiscountSetting, setIsDiscountSetting] = useState(false);
  const [tempContentImages, setTempContentImages] = useState([]);
  const [productPrice, setProductPrice] = useState(0);
  const [discountRate, setDiscountRate] = useState(0);
  const [itemPrice, setItemPrice] = useState(0);
  const [maxPointUse, setMaxPointUse] = useState(0);
  const [subTitle, setSubTitle] = useState("");
  const [tempDeleteImages, setTempDeleteImages] = useState([]);
  const [tempContentDeleteImages, setTempContentDeleteImages] = useState([]);
  const [memo1, setMemo1] = useState("")
  const [memo2, setMemo2] = useState("")
  const [loadCoachList, setLoadCoachLiset] = useState([])
  const [salesOption, setSalesOption] = useState({
    useDiscount : false,
    useOption : false,
    useQuestion : false,
    useSavePoint : true,
  })
  const [image, setImage] = useState([])
  const [mainImage, setMainImage] = useState(null)
  const [question, setQuestion] = useState([])
  const [usePoint, setUsePoint] = useState({
    type: 1,
    point: 0
  })
  const [savePoint, setSavePoint] = useState({
    type: 1,
    point: 0,
    ratio: 1,
  })
  const [optionProduct, setOptionProduct] = useState([])

  const [isDrag, setIsDrag] = useState(false)
  const [title, setTitle] = useState("");
  const [coachList, setCoachList] = useState([])
  const [coachType, setCoachType] = useState(1)
  const [isCalculateCoachPrice, setIsCalculateCoachPrice] = useState(false)

  const onTargetClick = () => {
      fileInputRef.current.click()
  }

  const onTargetMainImage = () => {
      mainImageInputRef.current.click()
  }
  
  const onDropMainImage = (files, event) => {
      uploadMainImage(files)
  }

  const onDrop = (files, event) => {
      setIsDrag(false)
      uploadFile(files)
  }

  const addImage = async (file) => {
    setImageLoading(true)
    let img = await resizeImg(file)
    setImageLoading(false)
    return img;
  }

  const onFileInputChange = (event) => {
      const { files } = event.target;
      uploadFile(files)
  }

  const onMainImageChange = (event) => {
      const { files } = event.target;
      uploadMainImage(files)
  }

  const uploadMainImage = async (file) => {
      if(!file) return false;
      if(!file[0]) return false;
      
      setImageLoading(true)
        if((file[0].type).includes("image/")) {
            await onUploadMainImage(file[0])
        }   else {
            setImageLoading(false)
            alert("이미지 파일을 업로드 해주세요.")
            return false;
        }
      setImageLoading(false)
  }
  
  const uploadFile = async (file) => {
      if(!file) return false;
      if(!file[0]) return false;

      let imgNum = image.length;

      let tempArr = []
      
      setImageLoading(true)
      for (let i = 0; i < file.length; i++) {
          if((file[i].type).includes("image/")) {
              if(imgNum < 5) {
                  let res = await onUploadImage(file[i])
                  tempArr.push(res)

                  imgNum += 1;
              }
          }   else {
            setImageLoading(false)
              alert("이미지 파일을 업로드 해주세요.")
              return false;
          }
      }
      setImageLoading(false)
      setImage(image.concat(tempArr))
  }
  
  const uploadMyImage = async (myImage, type) => {
    if(type === "main") {
      if(!mainImage || mainImage === "") {
        setMainImage(myImage)
      } else {
        alert("대표 사진이 있습니다.")
        return false;
      }
    } else if(type === "sub") {
      if(image.length < 5) {
        setImage([...image, myImage])
      } else {
        alert("소개 사진을 더 추가할 수 없습니다.")
        return false
      }
    }
  }

  const deleteImage = (index) => {
      let temp = []

      for (let i = 0; i < image.length; i++) {
          if(i != index) {
            temp.push(image[i])
          } else {
            if(location && location.state && location.state.isEdit) {
              tempDeleteImages.push(image[i])
            }
          }
      }

      setImage(temp)
  }

  const resizeImg = async (img) => {
      let file = img;	// 입력받은 file객체
      let _imageFile = club.clubID + "_mobileProdcut" + "_" + Math.floor(Date.now() / 1000).toString() + "_" + Math.random() + '.jpg';
      
      // 이미지 resize 옵션 설정 (최대 width을 100px로 지정)
      const options = { 
        maxSizeMB: 0.256
      }
      
      try {
        const compressedFile = await imageCompression(file, options);
        let resp = null;

        // const promise = imageCompression.getDataUrlFromFile(compressedFile);

        // await promise.then(async (result) => {
        //   await uploadImageToAWS(result, _imageFile);
        // })

        await uploadImageToAWS(compressedFile, _imageFile);

        return _imageFile
        
      } catch (error) {
          alert("이미지 등록에 오류가 발생했습니다. 다시 시도해주세요.")
          console.log(error);

          return false;
      }
  }

  const onUploadMainImage = async (img) => {
    let file = img;	// 입력받은 file객체
    
    // 이미지 resize 옵션 설정 (최대 width을 100px로 지정)
    const options = { 
      maxSizeMB: 0.256
    }
    
    try {
      const compressedFile = await imageCompression(file, options);

    //   const promise = imageCompression.getDataUrlFromFile(compressedFile);
    //   promise.then(result => {
    //     setMainImage(result)
    //   })

    setMainImage(compressedFile)
      
    } catch (error) {
        alert("이미지 등록에 오류가 발생했습니다. 다시 시도해주세요.")
        console.log(error);
    }
}

  const onUploadImage = async (img) => {
      let file = img;	// 입력받은 file객체
      
      // 이미지 resize 옵션 설정 (최대 width을 100px로 지정)
      const options = { 
        maxSizeMB: 0.256
      }
      
      try {
        const compressedFile = await imageCompression(file, options);

        //const promise = await imageCompression.getDataUrlFromFile(compressedFile);

        //return promise

        return compressedFile

      } catch (error) {
          alert("이미지 등록에 오류가 발생했습니다. 다시 시도해주세요.")
          console.log(error);
      }
  }
  
  const uploadImageToAWS = async (imageFile, _imageFile) => {

    let result = await uploadImageToServer(imageFile, _imageFile, 'clubdata/mobileProduct', imageFile.type);
    console.log('result : ', result)
    return _imageFile;

    // var AWS = require('aws-sdk');
    // var s3 = new AWS.S3({accessKeyId: process.env., secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY, region:'ap-northeast-2'});
    

    // // --> upload

    //const type = imageFile.split(';')[0].split('/')[1];
    // let contentDeposition = 'inline;filename="' + _imageFile + '"';
    // const base64Data = new Buffer.from(imageFile.replace(/^data:image\/\w+;base64,/, ""), 'base64');

    // const paramsupload = {
    //     Bucket: "healthnavi",
    //     Key: 'clubdata/mobileProduct/'+_imageFile,
    //     ACL:'public-read',
    //     Body: base64Data,
    //     ContentDisposition: contentDeposition,
    //     ContentType: type,
    // };
    // let uploadresult = await new Promise((resolve, reject) => {
    //     s3.upload(paramsupload, (err, data) => {
    //         if (err) {
    //             reject(err);
    //         }
    //         resolve(data);
    //     });
    // });
    
    // return _imageFile;
}

const uploadType2ImageToAWS = async (imageFile, num) => {

    let _imageFile = club.clubID + "_mobileProduct" + "_" + Math.floor(Date.now() / 1000).toString() + "_" + num + '.jpg';
    let result = await uploadImageToServer(imageFile, _imageFile, 'clubdata/mobileProduct', imageFile.type);
    console.log('result : ', result)
    return `mobileProduct/${_imageFile}`;

//   var AWS = require('aws-sdk');
//   var s3 = new AWS.S3({accessKeyId: process.env, secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY, region:'ap-northeast-2'});
  

//   //let _imageFile = club.clubID + "_mobileProduct" + "_" + Math.floor(Date.now() / 1000).toString() + "_" + num + '.jpg';

//   // --> upload

//   let contentDeposition = 'inline;filename="' + _imageFile + '"';
//   const base64Data = new Buffer.from(imageFile.replace(/^data:image\/\w+;base64,/, ""), 'base64');
//   const type = imageFile.split(';')[0].split('/')[1];

//   const paramsupload = {
//       Bucket: "healthnavi",
//       Key: 'clubdata/mobileProduct/'+_imageFile,
//       ACL:'public-read',
//       Body: base64Data,
//       ContentDisposition: contentDeposition,
//       ContentType: type,
//   };
//   let uploadresult = await new Promise((resolve, reject) => {
//       s3.upload(paramsupload, (err, data) => {
//           if (err) {
//               reject(err);
//           }
//           resolve(data);
//       });
//   });
  
//   return `mobileProduct/${_imageFile}`;
}

const uploadMainImageToAWS = async (imageFile) => {

    let _imageFile = club.clubID + "_mobileProduct_main" + "_" + Math.floor(Date.now() / 1000).toString() + '.jpg';
    let result = await uploadImageToServer(imageFile, _imageFile, 'clubdata/mobileProduct', imageFile.type);
    console.log('result : ', result)
    return `mobileProduct/${_imageFile}`;
//   var AWS = require('aws-sdk');
//   var s3 = new AWS.S3({accessKeyId: process.env, secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY, region:'ap-northeast-2'});

//   let _imageFile = club.clubID + "_mobileProduct_main" + "_" + Math.floor(Date.now() / 1000).toString() + '.jpg';

//   // --> upload

//   let contentDeposition = 'inline;filename="' + _imageFile + '"';
//   const base64Data = new Buffer.from(imageFile.replace(/^data:image\/\w+;base64,/, ""), 'base64');
//   const type = imageFile.split(';')[0].split('/')[1];

//   const paramsupload = {
//       Bucket: "healthnavi",
//       Key: 'clubdata/mobileProduct/'+_imageFile,
//       ACL:'public-read',
//       Body: base64Data,
//       ContentDisposition: contentDeposition,
//       ContentType: type,
//   };
//   let uploadresult = await new Promise((resolve, reject) => {
//       s3.upload(paramsupload, (err, data) => {
//           if (err) {
//               reject(err);
//           }
//           resolve(data);
//       });
//   });
  
//   return `mobileProduct/${_imageFile}`;
}

const onInit = () => {
  dispatch(init())
  setType1Contents("")
  setTitle("")
}
    
const deleteAWSImage = (imageName) => {
  //--> delete
//   var AWS = require('aws-sdk');
//   var s3 = new AWS.S3({accessKeyId: process.env., secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY, region:'ap-northeast-2'});
  
//   var params = {
//       Bucket: 'healthnavi',
//       Delete: { // required
//           Objects: [ // required
//               {
//                   Key: 'clubdata/'+imageName
//               },
//           ],
//       },
//   };

//   s3.deleteObjects(params, function (err, data) {
//       if (err) console.log(err, err.stack); // an error occurred
//       else console.log(data);           // successful response
//   });
}

const _backConfirm = async () => {
    let event = window.confirm(
      '페이지에서 나가시겠습니까? 변경된 정보는 저장되지 않습니다.',
    );
    if (event) {
      for (let i = 0; i < tempContentImages.length; i++) {
        deleteAWSImage(`mobileProduct/${tempContentImages[i]}`)
      }
      history.push(`/kiosk/product`);
    }
};

const onSelectProduct = (e) => {
  setSelectedProduct(e)
  setTitle(e.name)
  setProductPrice(e.salePrice)
  setDiscountRate(0)
  setItemPrice(e.salePrice)
  setSavePoint({
    ...savePoint,
    point: Math.ceil(Number(e.salePrice) * (savePoint.ratio / 100))
  })
}

const onChangeProductPrice = (e) => {
  setProductPrice(e.target.value)
  setDiscountRate(0)
  setItemPrice(e.target.value)
  setSavePoint({
    ...savePoint,
    point: Math.ceil(Number(inputNumberRemoveComma(e.target.value)) * (savePoint.ratio / 100))
  })
}

const onChangeDiscountInfo = (e) => {
  if(e.target.id == "discountRate") {
    if(e.target.value >= 0 && e.target.value <= 99) {
      setDiscountRate(e.target.value);
      setItemPrice(Math.round(Number(inputNumberRemoveComma(productPrice)) / (1-(e.target.value / 100))))
    }
  }
  if(e.target.id == "itemPrice") {
    setItemPrice(e.target.value);
    let discount = 100 - Math.round(((inputNumberRemoveComma(productPrice) / (inputNumberRemoveComma(e.target.value) / 100))))
    if(discount >=0 && discount <= 100) {
      setDiscountRate(100 - Math.round(((inputNumberRemoveComma(productPrice) / (inputNumberRemoveComma(e.target.value) / 100)))))
    } else {
      setDiscountRate('-')
    }
  }
}

const onModifyMobileProduct = async () => {
    console.log('mainImage : ', mainImage)
    console.log('image : ', image)
  if(!selectedProduct) {
    alert("회원권을 선택해주세요.")
    return false;
  }

  if(!title || title == "") {
    alert("키오스크 상품의 제목을 입력해주세요.")
    return false;
  }

  if(!type1Contents || type1Contents == "") {
    alert("키오스크 상품의 소개를 입력해주세요.")
    return false;
  }

  // utf8mb3 DB 는 이모지(4바이트 문자)를 저장할 수 없어 등록/수정을 차단한다
  if(hasEmoji(title) || hasEmoji(type1Contents)) {
    alert("이모지를 사용할 수 없습니다.")
    return false;
  }
  // 담당강사 지정 기능 제거로 인해 검증 로직 제거


  let clubKioskSalesItemData = {}
  let contents = ""
  let isNew = 1;
  let memos = "";
  let optionStr = ""
  let originPrice =""
  let coachIDs = ""
  let coachSelectList = ""
  let coachSelectType = 0
  let thisSavePoint = 0

  // 담당강사 지정 기능 제거로 인해 항상 담당강사 보여주지 않기로 설정
  // coachSelectType: 3 (담당강사 보여주지 않기)
  if(selectedProduct.type === 3) {
    coachSelectType = 3
    coachSelectList = ""
  }

  // 할인율 표기 기능 제거로 인해 항상 판매 가격을 원가로 설정
  originPrice = Number(inputNumberRemoveComma(productPrice))

  optionStr = JSON.stringify(optionProduct)

  // 상품 소개는 텍스트만 사용 (HTML 제거)
  // 엔터를 \n으로 변환 (명시적으로 보장)
  contents = String(type1Contents || '')
    .replace(/\r\n/g, '\n')  // Windows 줄바꿈을 \n으로
    .replace(/\r/g, '\n')     // Mac 구형 줄바꿈을 \n으로
  // \n 문자가 제대로 포함되어 있는지 확인
  console.log('contents before save:', JSON.stringify(contents))
  console.log('contents has newline:', contents.includes('\n'))
  console.log('contents length:', contents.length)

  // 대표사진과 소개사진 기능 제거로 인해 항상 빈 값으로 설정
  let mainImageURL = ""
  let photoURL = ""

  // 질문 추가 기능 제거로 인해 항상 빈 값으로 설정
  memos = ""

  // 포인트 설정 기능 제거로 인해 항상 초기화된 값으로 설정
  // 포인트 적립 안함 (savePointType: 0, savePoint: 0)
  // 포인트 사용 불가 (maxPointType: 3, maxPointUse: 0)
  thisSavePoint = 0

  if(location && location.state && location.state.isEdit) {
    isNew = 0;
    clubKioskSalesItemData = {
      clubItemID: selectedProduct.ClubItemID,
      clubKioskSalesItemID: location.state.selectProduct.clubKioskSalesItemID,
      clubID: club.clubID,
      title,
      body: contents,
      bodyType: 1, // 텍스트 타입으로 고정
      originPrice: originPrice,
      salePrice: Number(inputNumberRemoveComma(productPrice)),
      savePointType: 0, // 포인트 적립 안함
      savePoint: 0, // 포인트 적립 안함
      option: optionStr,
      salesType: location.state.selectProduct.salesType,
      subdscriptionDay: location.state.selectProduct.subdscriptionDay,
      isActive: location.state.selectProduct.isActive,
      registTime: location.state.selectProduct.registTime,
      subTitle: selectedProduct.name,
      mainImage: mainImageURL,
      images: photoURL,
      memos,
      maxPointUse: 0, // 포인트 사용 불가
      maxPointType: 3, // 포인트 사용 불가
      order: location.state.selectProduct.order,
      coachIDs,
      policy: "", // 센터 이용약관 제거
      coachSelectType,
      coachSelectList,
    }
  } else {
    clubKioskSalesItemData = {
      clubItemID: selectedProduct.ClubItemID,
      clubKioskSalesItemID: "",
      clubID: club.clubID,
      title,
      body: contents,
      bodyType: 1, // 텍스트 타입으로 고정
      originPrice: originPrice,
      salePrice: Number(inputNumberRemoveComma(productPrice)),
      savePointType: 0, // 포인트 적립 안함
      savePoint: 0, // 포인트 적립 안함
      option: optionStr,
      salesType: membershipType == 100?100:0,
      subdscriptionDay: 0,
      isActive: 0,
      registTime: Math.ceil(new Date().getTime() / 1000),
      subTitle: selectedProduct.name,
      mainImage: mainImageURL,
      images: photoURL,
      memos,
      maxPointUse: 0, // 포인트 사용 불가
      maxPointType: 3, // 포인트 사용 불가
      order: 0,
      coachIDs,
      policy: "", // 센터 이용약관 제거
      coachSelectType,
      coachSelectList,
    }
  }
  
  if(location && location.state && location.state.isEdit) {
    for (let i = 0; i < tempDeleteImages.length; i++) {
      if((tempDeleteImages[i]).indexOf('template') == -1) {
        deleteAWSImage(`${tempDeleteImages[i]}`)
      }
    }
    comparedToBeforeModification()
  }

  // 전송 전 body 필드에 \n이 포함되어 있는지 확인
  console.log('clubKioskSalesItemData.body:', JSON.stringify(clubKioskSalesItemData.body))
  console.log('clubKioskSalesItemData:', clubKioskSalesItemData)

  dispatch(modifyKioskProduct({
    clubID: club.clubID,
    socketKey,
    clubKioskSalesItemData,
    isNew,
  }))
}

// 상품소개가 텍스트로 변경되어 이미지 삭제 로직 불필요
const comparedToBeforeModification = () => {
  // 텍스트 입력으로 변경되어 이미지 삭제 로직 제거
}

// 키오스크는 포인트 비율 설정이 없음

// useEffect(() => {
//   if(salesInfo && salesInfo !== Number(savePoint.ratio)) {
//     let ratio = salesInfo.savePointRatio
//     //let point = Math.ceil(Number(inputNumberRemoveComma(productPrice))) * (salesInfo.savePointRatio / 100)
//     setSavePoint({...savePoint, ratio})
//   }
// }, [salesInfo])

useEffect(() => {
  onInit()
  dispatch(listItems({
    clubID: club.clubID,
    socketKey
  }))
  dispatch(
    loadCoach({
      clubID: club.clubID,
      playerID: user.playerID,
      socketKey,
    }),
  );
  dispatch(loadTemplate({
      clubID: club.clubID,
      socketKey,
  }))
  dispatch(loadCoachProfile({
      clubID: club.clubID,
      socketKey
  }))
  window.scroll(0, 0)
}, []);

useEffect(() => {
  if(location && location.state && location.state.isEdit) {
    let templateImage = [
      '1_mobileProdcut_1636423221_0.2957728325689166.jpg',
      '1_mobileProdcut_1634883220_0.6677131199215078.jpg',
      '1_mobileProdcut_1636423250_0.38462252196981916.jpg',
      '1_mobileProdcut_1636423303_0.29091055009463007.jpg',
      '1_mobileProdcut_1636423333_0.5439604089177359.jpg',
      '1_mobileProdcut_1636422778_0.7797188036092573.jpg',
      '1_mobileProdcut_1636422748_0.39779295718879304.jpg',
      '1_mobileProdcut_1635732827_0.36337724224361123.jpg',
      '1_mobileProdcut_1635733458_0.5221249271880171.jpg',
      '1_mobileProdcut_1635734027_0.3800332508929172.jpg',
      '1_mobileProdcut_1635734625_0.5165348459898818.jpg',
      '1_mobileProdcut_1635734628_0.28488481557001255.jpg',
      '1_mobileProdcut_1635734631_0.5789395696749773.jpg',
    ]
    if(items && items.length > 0) {

        let item = items.find((item) => {return item.ClubItemID == location.state.selectProduct.clubItemID})
        if(item) {
            let useQuestion = false;
            let useDiscount = false;
            let useOption = false;
            let useSavePoint = false;

            // 대표사진과 소개사진 기능 제거로 인해 초기화
            setMainImage(null)
            setImage([])
            setTitle(location.state.selectProduct.title)
            // 포인트 설정 기능 제거로 인해 초기화
            // 포인트 적립 안함 (type: 0, point: 0)
            setSavePoint({
                ...savePoint,
                type: 0,
                point: 0,
                ratio: 0
            })
            useSavePoint = false
            setProductPrice(location.state.selectProduct.salePrice)
            // 포인트 사용 불가 (type: 3, point: 0)
            setUsePoint({
                type: 3,
                point: 0
            })
            setSelectedProduct(item)

            if(item.type == 100)
            {
                setMembershipKind(2)
            }
            setMembershipType(item.type)

            // 담당강사 지정 기능 제거로 인해 초기화
            // 담당강사 보여주지 않기로 설정 (coachSelectType: 3)
            setCoachType(3)
            setCoachList([])
            setIsCalculateCoachPrice(false)

            // 할인율 표기와 질문 추가 기능 제거로 인해 초기화
            useQuestion = false;
            useDiscount = false;
            setQuestion([]);
            setDiscountRate(0);
            setItemPrice(location.state.selectProduct.salePrice);

            // 센터 이용약관 제거로 인해 초기화 (이미 제거됨)

            if(location.state.selectProduct.option && location.state.selectProduct.option !== "") {
                let opparse = JSON.parse(location.state.selectProduct.option);
                if(opparse && opparse.length > 0) {
                useOption = true
                }
                setOptionProduct(opparse)
            }

            setSalesOption({...salesOption, useDiscount, useQuestion, useOption, useSavePoint})
            // 상품 소개는 텍스트만 사용 (HTML 제거)
            // HTML 태그 제거하여 순수 텍스트만 추출
            let bodyText = location.state.selectProduct.body || "";
            // 줄바꿈 관련 HTML 태그를 줄바꿈 문자로 변환
            bodyText = bodyText.replace(/<br\s*\/?>/gi, '\n');
            bodyText = bodyText.replace(/<\/p>/gi, '\n');
            bodyText = bodyText.replace(/<\/div>/gi, '\n');
            bodyText = bodyText.replace(/<\/li>/gi, '\n');
            // HTML 태그 제거
            bodyText = bodyText.replace(/<[^>]*>/g, '');
            // HTML 엔티티 디코딩
            bodyText = bodyText.replace(/&nbsp;/g, ' ');
            bodyText = bodyText.replace(/&amp;/g, '&');
            bodyText = bodyText.replace(/&lt;/g, '<');
            bodyText = bodyText.replace(/&gt;/g, '>');
            bodyText = bodyText.replace(/&quot;/g, '"');
            // 연속된 공백만 제거 (줄바꿈은 유지)
            bodyText = bodyText.replace(/[ \t]+/g, ' ');
            // 연속된 줄바꿈을 최대 2개로 제한
            bodyText = bodyText.replace(/\n{3,}/g, '\n\n');
            bodyText = bodyText.trim();
            // 200자로 제한
            if (bodyText.length > 200) {
                bodyText = bodyText.substring(0, 200);
            }
            setType1Contents(bodyText)
            
            // 대표사진과 소개사진 기능 제거로 인해 이미지 초기화는 이미 위에서 처리됨
        }
    }
  }
}, [items]);
  
useEffect(() => {
  window.history.pushState(null, '', window.location.href);
  window.onpopstate = _backConfirm;
}, [location]);

useEffect(() => {
  return () => {
    window.onpopstate = () => {};
  };
}, []);


useEffect(() => {
  if(modifyRes && modifyRes == 1) {
    if(location && location.state && location.state.isEdit) {
      alert("키오스크 상품을 수정하였습니다.")
    } else {
      alert("키오스크 상품을 추가하였습니다.")
    }
    history.push(`/kiosk/product`);
  }
}, [modifyRes]);

  useEffect(() => {
    if(coach && coach.infos && coachProfileList) {
      let coachProfileData = []
      let tempCoachList = []

      console.log(coachProfileList, "coachProfileList")

      if(coachProfileList.categoryCoachDatas && coachProfileList.categoryCoachDatas.length > 0) {
        let tempArr = coachProfileList.categoryCoachDatas.map(item => {return item.coachs})
        console.log(tempArr,'tempArr')
        if(tempArr && tempArr.length > 0) {
          let temp = []
          for (let i = 0; i <tempArr.length; i++) {
            for (let j = 0; j < tempArr[i].length; j++) {
              temp.push({...tempArr[i][j]})
            }
          }
          coachProfileData = temp
        }
      }

      for (let i = 0; i < coach.infos.length; i++) {
        let coachProfileURL = ""
        
        let coachProfile = coachProfileData.find(item => {return item.coachProfileID === coach.infos[i].playerID})

        if(coachProfile && coachProfile.mainProfileURL && coachProfile.mainProfileURL !== "") {
          coachProfileURL = coachProfile.mainProfileURL
        }

        tempCoachList.push({...coach.infos[i], coachProfileURL, isActive: false, price: 0})
      }

      if(loadCoachList && loadCoachList.length > 0) {
        for (let i = 0; i < tempCoachList.length; i++) {
          let prevData = loadCoachList.find(item => item.coachID === tempCoachList[i].playerID)
          if(prevData){
            tempCoachList[i].price = inputNumberAutoComma(prevData.price)
            tempCoachList[i].isActive = true
          }
        }
      }
      
      setCoachList(tempCoachList)
    }
  }, [coach, coachProfileList, loadCoachList])


  console.log('membershipType : ', membershipType)
  return (
    <>
      {imageLoading &&
          <LoadingBlock />
      }
        <KioskProductRegist
          coach={coach && coach.infos}
          addImage={addImage}
          type1Contents={type1Contents}
          setType1Contents={setType1Contents}
          title={title}
          setTitle={setTitle}
          onInit={onInit}
          isEdit={location && location.state && location.state.isEdit}
          _backConfirm={_backConfirm}
          isDrag={isDrag}
          setIsDrag={setIsDrag}
          onDrop={onDrop}
          onDropMainImage={onDropMainImage}
          onTargetClick={onTargetClick}
          image={image}
          fileInputRef={fileInputRef}
          onFileInputChange={onFileInputChange}
          deleteImage={deleteImage}
          templateList={templateList}
          uploadMyImage={uploadMyImage}
          items={items}
          onSelectProduct={onSelectProduct}
          selectedProduct={selectedProduct}
          isDiscountSetting={isDiscountSetting}
          setIsDiscountSetting={setIsDiscountSetting}
          productPrice={productPrice}
          onChangeProductPrice={onChangeProductPrice}
          itemPrice={itemPrice}
          discountRate={discountRate}
          onChangeDiscountInfo = {onChangeDiscountInfo}
          savePoint={savePoint}
          setSavePoint={setSavePoint}
          onModifyMobileProduct={onModifyMobileProduct}
          maxPointUse={maxPointUse}
          setMaxPointUse={setMaxPointUse}
          tempContentImages={tempContentImages}
          setTempContentImages={setTempContentImages}
          memo1={memo1}
          setMemo1={setMemo1}
          memo2={memo2}
          setMemo2={setMemo2}
          salesOption={salesOption}
          setSalesOption={setSalesOption}
          usePoint={usePoint}
          setUsePoint={setUsePoint}
          question={question}
          setQuestion={setQuestion}
          optionProduct={optionProduct}
          setOptionProduct={setOptionProduct}
          mainImage={mainImage}
          setMainImage={setMainImage}
          setImage={setImage}
          mainImageInputRef={mainImageInputRef}
          onTargetMainImage={onTargetMainImage}
          onMainImageChange={onMainImageChange}
          salesInfo={null}
          coachList={coachList}
          setCoachList={setCoachList}
          coachType={coachType}
          setCoachType={setCoachType}
          setSelectedProduct={setSelectedProduct}
          membershipType={membershipType}
          setMembershipType={setMembershipType}

          membershipKind={membershipKind}
          setMembershipKind={setMembershipKind}

          isCalculateCoachPrice={isCalculateCoachPrice}
          setIsCalculateCoachPrice={setIsCalculateCoachPrice}
          club={club}
        />
      </>
  );
};

export default KioskProductRegistContainer;
